import { HttpErrorResponse, HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PoNotificationService } from "@po-ui/ng-components";
import { ErrorResponseModel } from "../models/responses/error.response.modal";


@Injectable({
    providedIn: 'root'
})
export class CatchHandler {
    constructor(
        private poNotification : PoNotificationService
    ){

    }

    handle(httpErrorResponse: HttpErrorResponse): ErrorResponseModel[]{
        if(httpErrorResponse.status !== HttpStatusCode.BadRequest) {
            this.poNotification.error(httpErrorResponse.message);
            return [];
        }

        return httpErrorResponse.error as ErrorResponseModel[];
    }
}